module.exports = __webpack_public_path__ + "static/img/swiper_REPAIR.c30c5b61.png";